import { pathEq, prop, find, propOr, any, propEq, isNil, filter, head } from 'ramda';
import { ROLES } from '../../lib/rights';

const RELAY_SESSION_USER_SENTINEL_ID = 'user'; // Relay assigns 'user' as the node id for the root SessionUser query field

export const getCurrentUserId = (user) =>
  head(filter((v) => !isNil(v) && v !== RELAY_SESSION_USER_SENTINEL_ID, [prop('userId', user), prop('id', user)]));

export const isUserAdmin = (user, userTeam) => {
  const currentUserId = getCurrentUserId(user);
  const member = find(pathEq(currentUserId, ['user', 'id']), propOr([], 'members', userTeam));
  return any(propEq(ROLES.admin, 'role'), propOr([], 'roles', member));
};
